import { GlobalDataViewSelector } from './global-data-view-selector-store';

export const setSelectedTagIds = (tagIds: string[]) => {
  GlobalDataViewSelector.selectedTagIds = tagIds;
};

export const setSelectedAppOwnersEmails = (emails: string[]) => {
  GlobalDataViewSelector.selectedAppOwnersEmails = emails;
};

export const setFilterValue = (value: string) => {
  GlobalDataViewSelector.filterValue = value;
};
